/**
 * LYMI customer reviews section (sections/lymi-product-reviews.liquid).
 * Shows the section's divider and heading only once Judge.me's review widget (its app block, inside
 * `.lymi-reviews__widget`) has content on the page, so the page never shows an empty "Customer reviews" heading
 * when the app block is missing or Judge.me is not running. Judge.me draws and controls the widget; nothing here
 * changes reviews or their controls.
 */
class LymiReviews extends HTMLElement {
  /** @type {ResizeObserver | null} */
  #observer = null;

  connectedCallback() {
    const widget = this.querySelector('.lymi-reviews__widget');
    if (!widget) return;

    this.#observer = new ResizeObserver(() => {
      if (widget.getBoundingClientRect().height > 0) {
        this.classList.add('is-ready');
        this.#observer?.disconnect();
        this.#observer = null;
      }
    });
    this.#observer.observe(widget);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('lymi-reviews')) {
  customElements.define('lymi-reviews', LymiReviews);
}
